// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__A62Jb","index":"styles_index__sxMsn"};